export default __webpack_public_path__ + "static/media/mission.91a7c17d.png";